function toggleHeaderOnScroll() {
    const header = document.getElementById('site-header');
    if (!header) return;
    header.classList.toggle('scrolled', window.scrollY > 200);
}

document.addEventListener('DOMContentLoaded', () => {

    const HAMBURGUER = document.getElementById('hamburger-icon')
    const CLOSE_MENU = document.getElementById('close-mobile')
    const MOBILE_MENU = document.getElementById('mobile-menu')

    HAMBURGUER.addEventListener( 'click', () => {
        MOBILE_MENU.classList.toggle('open')
    })

    CLOSE_MENU.addEventListener( 'click', () => {
        MOBILE_MENU.classList.toggle( 'open' )
    })

    window.addEventListener('scroll', toggleHeaderOnScroll);
    toggleHeaderOnScroll();
    
}, true)